import React, { Component } from 'react';

import { Close } from '@mui/icons-material';
import { Box, Modal } from '@mui/material';


const customStyles = {
  content : {
      width: '95%',
      maxWidth: '550px',
      minHeight: '400px'
  }
};

export default class SurveyTile extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loadSurvey: false,
            surveyUrl: '',
            previouslyLoaded: {
                loaded: false, 
                count: 0
            },
            open: true
        }
    }

    componentDidMount(props) {
        if(props) {
            this.setState({
                previouslyLoaded: JSON.parse(localStorage.getItem('surveyTitle')) || this.state.previouslyLoaded
            })			
        }
    }

    componentDidUpdate(nextProps) {
        //console.log('survey tile props updated %o', nextProps)
        if(nextProps.loadSurvey && !this.state.previouslyLoaded.loaded) {
            this.setState({
                loadSurvey: nextProps.loadSurvey,
                surveyUrl: nextProps.surveyUrl
            },)
        }	
    }

    handleOpen = () => { 
        this.setState({open: true});
      }

      handleClose = () => {
        this.setState({open: false, loadSurvey: false});
      }

    loadSurveyMonkey = () => {
        //console.log('load the survey monkey modal %o', this.state.loadSurvey)
        if(this.props.surveyUrl) {
            return <iframe src={this.props.surveyUrl || ''}></iframe>	
        }
        else {
          return null
        }
    }

    render () {
        if(this.state.loadSurvey && this.props.surveyUrl) {
            //console.log('load survey %o url %o propsOpen %o', this.state.loadSurvey, this.props.surveyUrl, this.state.open)
            return (
              <SurveyModal
                className={`modal--survey`}
                isOpen={this.state.loadSurvey}
                handleCloseModal={() => this.handleClose()}
                title={'Tell us what you think'}
              >
                <iframe src={this.props.surveyUrl}></iframe>
              </SurveyModal>
            )
        }
        else {
            return null
        }
        
      }
}

export const SurveyModal = ({className, isOpen, handleCloseModal, title, children}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => handleCloseModal()}
      //style={customStyles}
    >
      <Box className={className}>
        <div className='modal__close'>
          <button onClick={() => handleCloseModal()} type='button'>
            <Close className="btn-point-events md-light" />
          </button>
        </div>
        <div>
          <h2>{title}</h2>
        </div>
        {children}
      </Box>
      
    </Modal>
  )
}





